<template>
	<ul :class="cssClass" >
		<menuItem v-for="(item, index) in menuList[listKey]" :key="index" :classValue="item.id in menuList ? 'nav-parent':''">
			<template v-if="item.id in menuList">
				<a href="javascript:;">
					<i class="fa fa-fighter-jet" :style="{marginRight:'0.3rem'}"></i>
					{{item.title}}
				</a>
				<navMenu :cssClass="'nav nav-children'" :listKey="item.id" :menuList="menuList"></navMenu>
			</template>
			<template v-else>
				<a v-if="item.linkType == '2'" class="nav-content" :href="item.linkValue">{{item.title}}</a>
				<a v-else-if="item.linkType == '1'" class="nav-content" :href="'javascript:;'" @click="gotoView(item.linkValue.name, item.linkValue.params)">{{item.title}}</a>
				<a v-else-if="item.linkType == '90'" class="nav-content" :href="'javascript:;'" @click="$parent.showStayStateControl(true)">{{item.title}}</a>
				<a v-else-if="item.linkType == '91'" class="nav-content" :href="'javascript:;'" @click="$parent.showStayBillingControl(true)">{{item.title}}</a>
				<a v-else-if="item.linkType == '92'" class="nav-content" :href="'javascript:;'" @click="$parent.showAssistStateControl(true, item.linkValue)">{{item.title}}</a>
				<a v-else :href="'javascript:;'" class="nav-content">{{item.title}}</a>

			</template>
		</menuItem>
	</ul>
</template>
<script>
import menuItem from './menuItem';
export default {
	name: "navMenu",
	props:["cssClass","listKey", "menuList"],
	components:{
		menuItem
	},
	mounted(){
	},
	data(){
		return{
		}
	},
}
</script>